import React, { useEffect, useState } from "react";

/* Firebase imports */
import { ref, push } from "firebase/database";
import { database } from "../../firebase";

function NewsletterPopup() {

    const [show, setShow] = useState(false);
    const [thankYou, setThankYou] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    /* SUBMIT FUNCTION */
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            name: e.target.name.value,
            email: e.target.email.value,
            mobile: e.target.mobile.value,
            createdAt: new Date().toISOString()
        };

        try {

            const dbRef = ref(database, "newsletterSubscribers");

            await push(dbRef, data);

            console.log("Saved to Firebase:", data);

            setShow(false);
            setThankYou(true);

            setTimeout(() => {
                setThankYou(false);
            }, 85000);

        } catch (error) {
            console.error("Firebase Error:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    const visitorId =
        localStorage.getItem("visitorId") || "visitor_" + Date.now();

    localStorage.setItem("visitorId", visitorId);

    const [sessionStart] = useState(Date.now());
    const sessionDuration = Math.floor((Date.now() - sessionStart) / 1000);
    const [scrollDepth, setScrollDepth] = useState(0);
    useEffect(() => {

        const handleScroll = () => {

            const scrollTop = window.scrollY;
            const docHeight =
                document.documentElement.scrollHeight - window.innerHeight;

            const scrolled = Math.round((scrollTop / docHeight) * 100);

            if (scrolled > scrollDepth) {
                setScrollDepth(scrolled);
            }

        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);

    }, [scrollDepth]);

    const handleClose = async () => {

        try {

            // Get visitor location using IP API
            const response = await fetch("https://ipapi.co/json/");
            const location = await response.json();

            const visitorData = {
                visitorId: visitorId,
                event: "popup_closed",

                page: window.location.href,
                referrer: document.referrer,

                browser: navigator.userAgent,
                language: navigator.language,
                platform: navigator.platform,

                screenSize: `${window.innerWidth}x${window.innerHeight}`,

                scrollDepth: scrollDepth,
                sessionDuration: sessionDuration,

                city: location.city,
                region: location.region,
                country: location.country_name,
                ip: location.ip,

                createdAt: new Date().toISOString()
            };

            const dbRef = ref(database, "newsletterVisitors");

            await push(dbRef, visitorData);

            console.log("Visitor tracked:", visitorData);

        } catch (error) {
            console.error("Tracking error:", error);
        }

        setShow(false);
    };

    if (!show && !thankYou) return null;

    return (
        <>
            {show && (
                <div style={overlayStyle}>
                    <div style={modalStyle}>

                        <button style={closeBtn} onClick={handleClose}>✕</button>

                        <h2 style={titleStyle}>Subscribe to our Newsletter</h2>

                        <p style={subtitleStyle}>
                            Get latest tech insights, product updates and startup strategies.
                        </p>

                        <form onSubmit={handleSubmit}>

                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                required
                                style={inputStyle}
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                required
                                style={inputStyle}
                            />

                            <input
                                type="tel"
                                name="mobile"
                                placeholder="Mobile Number"
                                required
                                style={inputStyle}
                            />

                            <button type="submit" style={buttonStyle}>
                                Subscribe
                            </button>

                        </form>

                    </div>
                </div>
            )}

            {thankYou && (
                <div style={overlayStyle}>
                    <div style={thankModal}>

                        <h2 style={thankTitle}>🎉 Thanks for Subscribing!</h2>

                        <p style={subtitleStyle}>
                            You are now part of our newsletter community.
                        </p>

                    </div>
                </div>
            )}
        </>
    );
}

export default NewsletterPopup;


/* ---------- STYLES ---------- */

const gradient = "linear-gradient(to right, #ec4899, #ef4444, #8b5cf6)";

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.65)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999
};

const modalStyle = {
    width: "420px",
    maxWidth: "90%",
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    position: "relative",
    boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
    textAlign: "center"
};

const thankModal = {
    width: "350px",
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 25px 70px rgba(0,0,0,0.35)"
};

const closeBtn = {
    position: "absolute",
    top: "12px",
    right: "15px",
    border: "none",
    background: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#666"
};

const titleStyle = {
    fontSize: "24px",
    marginBottom: "10px",
    background: gradient,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "700"
};

const thankTitle = {
    fontSize: "24px",
    marginBottom: "10px",
    background: gradient,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "700"
};

const subtitleStyle = {
    fontSize: "14px",
    marginBottom: "22px",
    color: "#555",
    lineHeight: "1.5"
};

const inputStyle = {
    width: "100%",
    padding: "12px",
    marginBottom: "14px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none"
};

const buttonStyle = {
    width: "100%",
    padding: "13px",
    border: "none",
    borderRadius: "8px",
    background: gradient,
    color: "#fff",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer"
};